import { Component, OnInit, Input } from '@angular/core'
import { ValidatorFn } from '@angular/forms'

import { BaseInputComponent } from 'app/shared/components/forms/base-input-component'

@Component({
    selector: 'app-text-input',
    templateUrl: './text-input.component.html',
    styleUrls: ['./text-input.component.css'],
    standalone: false
})
export class TextInputComponent extends BaseInputComponent implements OnInit {
    @Input() maxLength: number
    @Input() isReadOnly = false
    @Input() showCharsUsed = true
    @Input() placeholder = ''
    @Input() matchPattern: string
    @Input() helperText = ''

    constructor() {
        super()
    }

    ngOnInit() {
        if (!this.control || !this.matchPattern) {
            return
        }

        try {
            const regex = new RegExp(this.matchPattern)
            const patternValidator: ValidatorFn = control => {
                const value = control.value
                if (value === null || value === undefined || value === '') {
                    return null
                }
                return regex.test(value) ? null : { pattern: true }
            }

            const existingValidator = this.control.validator
            const validators: ValidatorFn[] = []

            if (existingValidator) {
                validators.push(existingValidator)
            }
            validators.push(patternValidator)

            this.control.setValidators(validators)
            this.control.updateValueAndValidity({ emitEvent: false })
        } catch (error) {
            console.error('Invalid matchPattern provided to TextInputComponent', this.matchPattern, error)
        }
    }
}
